import PropTypes from "prop-types";
import React from "react";
import { reduxForm } from "redux-form";

import Button from "cxa-components/button";
import PageIndicator from "components/common/page-indicator/pageIndicator";

import NoGroupingLayout from "./layouts/no-grouping";
import HorizontalGroupingLayout from "./layouts/horizontal-grouping";
import TableGroupingLayout from "./layouts/table-grouping";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

export const Validate = (values, props) => {
  const errors = {};
  const { questionsInfo, page, intl } = props;
  const currentSection = questionsInfo.sections[page - 1];

  if (currentSection) {
    currentSection.subsections.forEach(subSection => {
      subSection.questions.forEach(question => {
        //eslint-disable-line complexity
        if (!question) {
          return;
        }
        switch (question.tag) {
          case "height":
            if (values[`question_${question.tag}`]) {
              const numericValue = parseFloat(values[`question_${question.tag}`]);
              if (numericValue < 0) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valuePositiveDescription
                );
              }
              const unit = values["height_unit"];
              if (
                (unit == "cm" && numericValue < 35) ||
                (unit == "inches" && numericValue < 14) ||
                (unit == "cm" && numericValue > 300) ||
                (unit == "inches" && numericValue > 118.11)
              ) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valueUnrealisticDescription
                );
              }
            }
            if (!values[`question_${question.tag}`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
            break;
          case "weight":
            if (values[`question_${question.tag}`]) {
              const numericValue = parseFloat(values[`question_${question.tag}`]);
              if (numericValue < 0) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valuePositiveDescription
                );
              }
              const unit = values["weight_unit"];
              if (
                (unit == "kg" && numericValue < 15) ||
                (unit == "lb" && numericValue < 33) ||
                (unit == "kg" && numericValue > 400) ||
                (unit == "lb" && numericValue > 880)
              ) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valueUnrealisticDescription
                );
              }
            }
            if (!values[`question_${question.tag}`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
            break;
          case "waist":
            if (values[`question_${question.tag}`]) {
              const numericValue = parseFloat(values[`question_${question.tag}`]);
              if (numericValue < 0) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valuePositiveDescription
                );
              }
              const unit = values["waist_unit"];
              if (
                (unit == "cm" && numericValue < 35) ||
                (unit == "inches" && numericValue < 14) ||
                (unit == "cm" && numericValue > 250) ||
                (unit == "inches" && numericValue > 98.43)
              ) {
                errors[`question_${question.tag}`] = intl.formatMessage(
                  messages.valueUnrealisticDescription
                );
              }
            }
            break;
          case "physical_activity_hours_sleeping": {
            const numericValueHours = parseInt(values[`question_${question.tag}`]);
            if (numericValueHours < 0) {
              errors[`question_${question.tag}`] = intl.formatMessage(
                messages.valuePositiveDescription
              );
            }
            if (numericValueHours > 24) {
              errors[`question_${question.tag}`] = intl.formatMessage(
                messages.valueMaxDescription,
                {
                  value0: "24",
                }
              );
            }
            const numericValueMinutes = parseInt(values[`${question.tag}_minutes`]);
            if (numericValueMinutes < 0) {
              errors[`${question.tag}_minutes`] = intl.formatMessage(
                messages.valuePositiveDescription
              );
            }
            if (numericValueMinutes > 59) {
              errors[`${question.tag}_minutes`] = intl.formatMessage(messages.valueMaxDescription, {
                value0: "59",
              });
            }
            if (!values[`question_${question.tag}`] && !values[`${question.tag}_minutes`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
            if (
              (!numericValueHours && numericValueMinutes == 0) ||
              (!numericValueMinutes && numericValueHours == 0) ||
              (numericValueMinutes == 0 && numericValueHours == 0)
            ) {
              errors[`question_${question.tag}`] = intl.formatMessage(
                messages.valueUnrealisticDescription
              );
              errors[`${question.tag}_minutes`] = intl.formatMessage(
                messages.valueUnrealisticDescription
              );
            }
            if (!values[`question_${question.tag}`] && !values[`${question.tag}_minutes`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
            break;
          }
          case "physical_activity_hours_driving":
          case "physical_activity_hours_at_work":
          case "physical_activity_hours_ideal_work": {
            const numericValueHours = parseInt(values[`question_${question.tag}`]);
            if (numericValueHours < 0) {
              errors[`question_${question.tag}`] = intl.formatMessage(
                messages.valuePositiveDescription
              );
            }
            if (numericValueHours > 24) {
              errors[`question_${question.tag}`] = intl.formatMessage(
                messages.valueMaxDescription,
                {
                  value0: "24",
                }
              );
            }
            const numericValueMinutes = parseInt(values[`${question.tag}_minutes`]);
            if (numericValueMinutes < 0) {
              errors[`${question.tag}_minutes`] = intl.formatMessage(
                messages.valuePositiveDescription
              );
            }
            if (numericValueMinutes > 59) {
              errors[`${question.tag}_minutes`] = intl.formatMessage(messages.valueMaxDescription, {
                value0: "59",
              });
            }
            if (!values[`question_${question.tag}`] && !values[`${question.tag}_minutes`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
            break;
          }
          case "current_health_diagnose":
          case "immediate_family_health":
          case "musculoskeletal":
            //This is to omit required validation for above questions
            break;
          default:
            if (!values[`question_${question.tag}`]) {
              errors[`question_${question.tag}`] = intl.formatMessage(messages.requiredDescription);
            }
        }
      });
    });
  }
  return errors;
};

export const Pages = ({
  questionsInfo,
  handleSubmit,
  previousPage,
  nextPage,
  goTo,
  page,
  intl,
  sectionValidationError,
  error,
  ...props
}) => {
  const currentSection = questionsInfo.sections[page - 1];
  const isLastPage = questionsInfo.sections.length === page;
  return (
    <form
      onSubmit={handleSubmit(values => nextPage(isLastPage, currentSection.sectionTag, values))}
    >
      <PageIndicator
        pageCount={questionsInfo.sections.length}
        currentPage={page}
        enableLinks={questionsInfo.assessmentStatus.hraQuestionsAnswered === "true"}
        handleClick={goTo}
      />

      {currentSection.subsections.map(sub => {
        switch (sub.layout) {
          case "no_grouping":
            return <NoGroupingLayout key={sub.subsectionTag} subsection={sub} {...props} />;
          case "horizontal_grouping":
            return <HorizontalGroupingLayout key={sub.subsectionTag} subsection={sub} {...props} />;
          case "table_grouping":
            return <TableGroupingLayout key={sub.subsectionTag} subsection={sub} {...props} />;
          default:
            return "";
        }
      })}

      <p className="error">{error}</p>

      <PageIndicator
        pageCount={questionsInfo.sections.length}
        currentPage={page}
        enableLinks={questionsInfo.assessmentStatus.hraQuestionsAnswered === "true"}
        handleClick={goTo}
      />
      <p className="cxa-questionnaire__control-panel">
        {page !== 1 && (
          <Button type="button" className="previous" onClick={previousPage} secondary>
            {intl.formatMessage(messages.previousTextDescription)}
          </Button>
        )}
        <Button primary type="submit">
          {isLastPage
            ? intl.formatMessage(messages.submitTextDescription)
            : intl.formatMessage(messages.nextTextDescription)}
        </Button>
      </p>
    </form>
  );
};

Pages.propTypes = {
  handleSubmit: PropTypes.func,
  previousPage: PropTypes.func,
  nextPage: PropTypes.func,
  goTo: PropTypes.func,
  page: PropTypes.number,
  questionsInfo: PropTypes.object,
  primaryQuestion: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(
  reduxForm({
    validate: Validate,
    persistentSubmitErrors: false,
  })(Pages)
);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/dynamic-page.jsx